import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";
import memberService from "app/services/memberService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
// import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import config from "config.json";
import moment from "moment";
import { MdRefresh, MdSearch } from "react-icons/md";
import { AiFillFileExcel } from "react-icons/ai";
import Tooltip from "rc-tooltip";
import {
  ExportAirCalendar,
  getAirCalendar,
} from "./Components/Service/bookingService";

const { dateTimeFormat } = config;

class AirCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      data: [],
      sizePerPage: 10,
      dataCount: 0,
      loading: true,
      FromDate: "",
      ToDate: "",
      SearchBy: "",
      PNR: "",
    };
  }

  dateFormater = (cell, row) => {
    if (cell) {
      return moment(cell).format(dateTimeFormat);
    }
  };
  columns = [
    {
      dataField: "bookingDate",
      text: "Booking Date",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: this.dateFormater,
    },
    {
      dataField: "from",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },

    {
      dataField: "to",
      text: "To",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "departureDate",
      text: "Departure Date",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: this.dateFormater,
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "gender",
      text: "Gender",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "passengerName",
      text: "Pax Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
  ];
  rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  };
  NoDataIndication = () => {
    const { loading } = this.state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  ExportAirCalendar = async () => {
    const { page, sizePerPage, FromDate, ToDate, SearchBy, PNR } = this.state;
    const query = queryString.getQueryStringFromObj({
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    });
    if (this.state.dataCount !== 0) {
      this.setState({ loading: true });
    }

    const response = await ExportAirCalendar(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_AirCalendar.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    this.setState({
      loading: false,
    });
  };

  loadAirCalendarDetails = async () => {
    const {
      page,
      sizePerPage,
      affiliateId,
      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    } = this.state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      affiliateId,
      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      FromDate,
      ToDate,
      SearchBy,
      PNR,
    });
    if (this.state.dataCount !== 0) {
      this.setState({ loading: true });
    }

    const response = await getAirCalendar(query);
    //  console.log(response);

    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    this.setState({
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    });
  };

  async componentDidMount() {
    await this.loadAirCalendarDetails();
  }

  handleTableChange = async (type, { page, sizePerPage }) => {
    //debugger;
    const currentIndex = (page - 1) * sizePerPage;
    this.setState(() => ({
      page,
      sizePerPage,
    }));
    setTimeout(async () => {
      await this.loadAirCalendarDetails();
    }, 10);
  };

  handleSearchChanges = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    setTimeout(async () => {
      await this.loadAirCalendarDetails();
    }, 10);
  };

  handleExport = async () => {
    this.setState(() => ({
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await this.ExportAirCalendar();
    }, 10);
  };

  refreshFilter = async (e) => {
    this.setState({
      FromDate: "",
      ToDate: "",
      SearchBy: "",
      PNR: "",
    });
    setTimeout(async () => {
      await this.loadAirCalendarDetails();
    }, 10);
  };

  render() {
    const { data, sizePerPage, page, dataCount, loading } = this.state;

    const sizePerPageRenderer = ({
      options,
      currSizePerPage,
      onSizePerPageChange,
    }) => (
      <>
        <label className="mr-2">Page Size</label>
        <div className="btn-group mr-4" role="group">
          {options.map((option) => {
            const isSelect = currSizePerPage === `${option.page}`;
            return (
              <button
                key={option.text}
                type="button"
                onClick={() => onSizePerPageChange(option.page)}
                className={`btn btn-sm ${
                  isSelect ? "btn-primary" : "btn-secondary"
                }`}
              >
                {option.text}
              </button>
            );
          })}
        </div>
      </>
    );

    const paginationOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: dataCount,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "15",
          value: 15,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "50",
          value: 50,
        },
      ],
      sizePerPageRenderer,
    };

    return (
      <>
        <div>
          <Helmet>
            <title>Air Calendar</title>
          </Helmet>
          <Breadcrumb routeSegments={[{ name: "Air Calendar" }]}></Breadcrumb>

          <div className="card card-body text-left " id="bookingHistory">
            <div className="card-body p-0 mr-2 ">
              <div className=" mx-auto">
                <div className="bookingList-header">
                  <div className="row ">
                    <div className="col-md-3 col-12">
                      <div className="form-group">
                        <label> Date From</label>
                      </div>
                      <input
                        type="date"
                        className="form-control"
                        name="FromDate"
                        // placeholder="Date From"
                        value={this.state.FromDate}
                        onChange={this.handleSearchChanges}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md-3 col-12">
                      <div className="form-group">
                        <label> Date To</label>
                      </div>
                      <input
                        type="date"
                        className="form-control"
                        name="ToDate"
                        //  placeholder="Date To"
                        value={this.state.ToDate}
                        onChange={this.handleSearchChanges}
                      />
                    </div>
                    <div className="col-md-3 col-12">
                      <div className="form-group">
                        <label> Search PNR</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="PNR"
                        value={this.state.PNR}
                        onChange={this.handleSearchChanges}
                      />
                    </div>
                    <div
                      className="col d-flex justify-content-end mb-3"
                      style={{ marginTop: "3%" }}
                    >
                      <button
                        className="btn btn-outline-primary"
                        onClick={this.handleSearchChanges}
                      >
                        <MdSearch className="" size={18} />
                      </button>
                      <button
                        className="btn btn-outline-primary mx-2"
                        onClick={this.refreshFilter}
                      >
                        <MdRefresh className="" size={18} />
                      </button>
                      <Tooltip placement="top" overlay="Export Excel">
                        <Button
                          variant="outline-primary"
                          //className="ml-2"
                          onClick={this.handleExport}
                        >
                          <AiFillFileExcel className="" size={"2em"} />
                        </Button>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <BootstrapTable
                hover
                remote
                keyField="id"
                data={data}
                columns={this.columns}
                pagination={paginationFactory(paginationOptions)}
                onTableChange={this.handleTableChange}
                noDataIndication={() => <this.NoDataIndication />}
                //  loading={loading}
                // overlay={overlayFactory({
                //   spinner: true,
                //   styles: {
                //     overlay: (base) => ({
                //       ...base,
                //       background: "rgba(120, 120, 120, 0.5)",
                //     }),
                //   },
                // })}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                expandRow={this.expandRow}
                rowStyle={this.rowStyle}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AirCalendar;
